<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { Modal, ModalBody, ModalFooter, ModalHeader, TabContent, TabPane } from "sveltestrap";
  import { error, success } from "../../../../public/my-theme";
  import type { Fn } from "../../../global";
  import type { Third } from "../../../Model/Third";
  import { legalGuardianService } from "../../../services";
  import WitnessInfoForm from "./WitnessInfoForm.svelte";
  import type { LegalGuardian } from "../../../Model/LegalGuardian";
    import LegalGuardianInfoForm from "./LegalGuardianInfoForm.svelte";

  export let legalGuardianThird: Third;
  export let diligenceId: string;
  export let open = false;
  export let toggle: Fn = undefined;

  $: load(diligenceId, legalGuardianThird)

  let size = "lg";
  let legalGuardian: LegalGuardian;

  const dispatch = createEventDispatcher();

  async function load(diligenceId, denouncedThird){
    if (diligenceId && denouncedThird) {
      let legalGuardianArray: LegalGuardian[] = await legalGuardianService.findByDiligenceNumber(diligenceId)
      legalGuardian = legalGuardianArray.find(c => c.representante == denouncedThird.id)
    }
  }

  async function saveLegalGuardian() {
    try {
      save()
      toggle()
      success("Datos guardados con exito");
    } catch (err) {
      error("Comprueba los campos");
    }
  }

  async function changeThirdList(third){
    legalGuardian.representante = third.id;
    save()
  }

  async function save(){
    await legalGuardianService.saveLegalGuardian(legalGuardian);

    dispatch('saveLegalGuardian');
  }

</script>

<Modal isOpen={open} {toggle} {size}>
  <ModalHeader {toggle}>Editar</ModalHeader>
  <ModalBody>
    <TabContent>
      <TabPane tabId="Datos" tab="Datos" active>
        {#if legalGuardian}
          <LegalGuardianInfoForm legalGuardian={legalGuardian} on:changeThirdLIst={(event) => changeThirdList(event.detail)}/>
        {/if}
      </TabPane>
    </TabContent>
  </ModalBody>
  <ModalFooter>
    <button class="btn btn-success" type="button" on:click={saveLegalGuardian}>Guardar</button>
  </ModalFooter>
</Modal>

